// General settings management
import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';
import { db } from './config';

const SETTINGS_ID = 'general';

/**
 * Get general settings
 */
export const getGeneralSettings = async () => {
  try {
    const settingsRef = doc(db, 'settings', SETTINGS_ID);
    const snapshot = await getDoc(settingsRef);
    
    if (snapshot.exists()) {
      return { id: snapshot.id, ...snapshot.data() };
    }
    
    // Return default settings if none exist
    return {
      id: SETTINGS_ID,
      // Business Information
      businessName: '',
      businessEmail: '',
      businessPhone: '',
      businessAddress: '',
      businessWebsite: '',
      taxId: '',
      vatNumber: '',
      
      // Payment Settings
      currency: 'GBP',
      stripePublishableKey: '', // Status only, not editable here
      paymentMethods: {
        stripe: true,
        paypal: false
      },
      
      // Email Settings
      emailServiceProvider: 'smtp', // 'smtp', 'firebase-extension', 'emailjs', 'sendgrid', 'resend', 'custom'
      emailServiceUrl: '',
      emailFromName: 'Fabiha @ FreeSpiritFabiha',
      emailFromAddress: 'Fabiha@freespiritfabiha.com',
      // SMTP Settings (for IONOS)
      smtpHost: 'smtp.ionos.co.uk',
      smtpPort: 465, // IONOS requires port 465 with SSL
      smtpUser: 'Fabiha@freespiritfabiha.com',
      smtpPassword: '', // Set in Firebase Functions config
      
      // SFTP Settings (for file uploads)
      sftpHost: 'access-5019186208.webspace-host.com',
      sftpPort: 22,
      sftpUsername: 'su247761',
      sftpPassword: '', // Set in Firebase Functions config as SFTP_PASSWORD secret
      sftpDefaultFolder: 'email-files',
      sftpPublicUrlBase: 'https://freespiritfabiha.com',
      
      // Notification Settings
      notifications: {
        newOrder: true,
        newBooking: true,
        newSubscriber: false,
        paymentReceived: true,
        bookingCancelled: true
      },
      notificationEmail: '',
      
      // System Settings
      timezone: 'Europe/London',
      dateFormat: 'DD/MM/YYYY',
      timeFormat: '12h', // '12h' or '24h'
      language: 'en',
      autoRefreshInterval: 30, // seconds
      
      // Security Settings
      sessionTimeout: 60, // minutes
      requirePasswordChange: false,
      twoFactorEnabled: false,
      
      createdAt: null,
      updatedAt: null
    };
  } catch (error) {
    console.error('Error getting general settings:', error);
    return null;
  }
};

/**
 * Update general settings
 */
export const updateGeneralSettings = async (settings) => {
  try {
    const settingsRef = doc(db, 'settings', SETTINGS_ID);
    await setDoc(settingsRef, {
      ...settings,
      updatedAt: serverTimestamp()
    }, { merge: true });
    return { success: true };
  } catch (error) {
    console.error('Error updating general settings:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Get Stripe publishable key status (from environment)
 */
export const getStripeKeyStatus = () => {
  const key = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || '';
  return {
    configured: key.trim() !== '',
    masked: key ? `${key.substring(0, 12)}...${key.substring(key.length - 4)}` : 'Not configured'
  };
};



